import React from "react";
import VisualizarCarteiras from "../componentes/VisualizarCarteiras";

const VisualizarCarteirasPublic = () => {
  return (
   <VisualizarCarteiras />
  )
}

export default VisualizarCarteirasPublic;